import {
  ActivityIcon,
  DumbbellIcon,
  WavesIcon,
  SparklesIcon,
  LeafIcon,
  HammerIcon,
  UsersIcon,
  UtensilsIcon,
  TicketIcon,
  CalculatorIcon,
} from 'lucide-react'
import type { BranchItem } from '../types/content'

export const branches: BranchItem[] = [
  {
    name: 'Fysiotherapie',
    description: 'Praktijken die gevonden willen worden op klacht en wijk.',
    icon: ActivityIcon,
    slug: 'fysiotherapiepraktijk',
  },
  {
    name: 'Sportscholen',
    description: 'Proefles-aanvragen uit de directe omgeving.',
    icon: DumbbellIcon,
    slug: 'sportschool',
  },
  {
    name: 'Zwemverenigingen',
    description: 'Ledeninformatie, lesroosters en inschrijvingen op orde.',
    icon: WavesIcon,
    slug: 'sportvereniging',
  },
  {
    name: 'Schoonmaakbedrijven',
    description: 'Zakelijke aanvragen in plaats van losse klussen.',
    icon: SparklesIcon,
    slug: 'schoonmaakbedrijf',
  },
  {
    name: 'Hoveniers',
    description: 'Werk laten zien met projecten uit de eigen regio.',
    icon: LeafIcon,
    slug: 'hovenier',
  },
  {
    name: 'Renovatiebedrijven',
    description: 'Grotere opdrachten binnenhalen met bewijs van vakwerk.',
    icon: HammerIcon,
    slug: 'renovatiebedrijf',
  },
  {
    name: 'Uitzendbureaus',
    description: 'Kandidaten en opdrachtgevers via twee heldere routes.',
    icon: UsersIcon,
    slug: 'uitzendbureau',
  },
  {
    name: 'Horeca',
    description: 'Menukaart, openingstijden en reserveringen altijd actueel.',
    icon: UtensilsIcon,
  },
  {
    name: 'Evenementenbureaus',
    description: 'Portfolio en aanvraagformulier die elkaar versterken.',
    icon: TicketIcon,
    slug: 'evenementenbureau',
  },
  {
    name: 'Financieel advies',
    description: 'Vertrouwen wekken voordat het eerste gesprek begint.',
    icon: CalculatorIcon,
    slug: 'financieel-adviseur',
  },
]
